<template>
    <div class="shopping_cart_box bar_content_box" id="shopping_cart_box">
        <div class="content_title fix">
            <div class="f-fl font_color">
                <i class="detail_ico_25 collect_ico">
                    <img class="wishlist_ico" src="https://resource.rcclchina.com.cn/tui2/detail/wishlist.png">
                </i> 收藏夹
            </div>
            <div class="f-fr" id="close_btn" @click="closeMenu">
                <i role="button" class="detail_ico_25 close_block_ico">
                    <img src="https://resource.rcclchina.com.cn/tui2/detail/close.png"></i>
            </div>
        </div>

        <div class="shoppingcart_cruise clearfix">
            <div class="cruise_title homeport_cruise" :class="{ 'cruise_bottom_border': isShowHp}" @click="isShowHp=true">
                <span>中国出发航线</span>
                <i class="cruise-tab-badge" v-show="hpWishLists.length>0">{{hpWishLists.length}}</i>
            </div>
            <div class="cruise_title tui_cruise" :class="{ 'cruise_bottom_border': !isShowHp}" @click="isShowHp=false">
                <span>海外出发航线</span>
                <i class="cruise-tab-badge" v-show="rowWishLists.length>0">{{rowWishLists.length}}</i>
            </div>
        </div>

        <div class="shopping_cart_list content_box" v-if="currentWishtLists.length > 0">
            <WishListFloatItem class="cruiseItem"
                v-for="(cruise) in currentWishtLists" :key="('wishtList_'+cruise.cruiseId)"
                :cruise="cruise"
                :onWishListDelete="onWishListDelete"
            />
        </div>

        <!--空提示-->
        <div class="shopping_cart_isnull" v-if="wishLists.length == 0 && isShow">
            <img src="https://resource.rcclchina.com.cn/tui2/detail/shopping_cart.png" alt="">
            <div class="tips_text">
                你的收藏夹还是空的~这怎么能行，快来添加您的美好旅行计划吧
            </div>
            <a @click="goCruiseSearch" class="link_btn noCruise">搜索及添加心仪航线</a>
        </div>

        <div class="bottom_btn" id="shoppingCart_NextButton" @click="goCruiseSearch" v-if="wishLists.length > 0">
            查看更多收藏路线
        </div>

    </div>
</template>

<script>
import api from '@/api'
const WishListFloatItem = () => import('@/components/FloatMenu/WishListFloatItem')
export default {
    name: "WishListFloatMenu",
    components: {
        WishListFloatItem
    },
    props: {
        closeMenu: {
            type: Function
        },
    },
    data () {
        return {
            isShowHp: true,
            wishLists: [],
            isShow: false
        }
    },
    beforeMount () {
        this.initPage ()
    },
    methods: {
        async initPage () {
            const { success, data } = await api.cruise.getWishList({
                offset: 0,
                limit: 100
            })
            this.isShow = true
            if (success && data && data.cruises && data.cruises.length > 0) {
                this.wishLists = data.cruises
            }
        },
        goCruiseSearch () {
            if (this.isShowHp) {
                return location.href = process.env.VUE_APP_BASE_URL + '/Rccl.Cruise/CruiseSearch/Search'
            } else {
                return location.href = process.env.VUE_APP_TUI_URL + '/Cruise/Search'
            }
        },
        async onWishListDelete (cruiseId) {
            const { success } = await api.cruise.deleteWishList({
                cruiseId
            })
            if (success) {
                this.wishLists = this.wishLists.filter(r=>r.cruiseId != cruiseId)
            }
        }
    },
    computed: {
        hpWishLists () {
            return this.wishLists.filter(r=>!r.isRow)
        },
        rowWishLists () {
            return this.wishLists.filter(r=>r.isRow)
        },
        currentWishtLists () {
            return this.isShowHp ? this.hpWishLists: this.rowWishLists
        }
    },
    watch: {
        
    }
}
</script>

<style lang="less" scoped>
.bar_content_box {
    position: relative;
    height: 100%;
    overflow: initial;
    padding: 40px 0px;
    .content_title {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        font-size: 16px;
        font-weight: bold;
        background: #e5f4ff;
        padding: 7px 10px 7px 0px;
        .font_color {
            color: black;
        }
        .wishlist_ico {
            position: relative;
            padding-left: 8px;
            top: -1px;
        }
    }
    .shoppingcart_cruise {
        width: 100%;
        height: 40px;
        background: white;
        .cruise_title {
            float: left;
            padding-left: 25px;
            font-size: 14px;
            padding-top: 9px;
            width: 50%;
            line-height: 20px;
            padding-bottom: 6px;
            border-bottom: 3px solid #F2F5F8;
            span {
                font-weight: bold;
                cursor: pointer;
                vertical-align: middle;
            }
            .cruise-tab-badge {
                color: #fff;
                background-color: #ff3022;
                border-radius: 50%;
                margin-left: 4px;
                font-size: 12px;
                width: 16px;
                height: 16px;
                line-height: 16px;
                display: inline-block;
                text-align: center;
                vertical-align: middle;
            }
        }
        .cruise_bottom_border {
            border-bottom: 3px solid #54a3de;
        }
    }
    .shopping_cart_list {
        position: absolute;
        top: 80px;
        bottom: 40px;
        width: 100%;
        margin: 0;
        overflow-y: auto;
        font-size: 12px;
        background: white;
        padding-bottom: 30px;
    }

    .cruiseItem {
        border-bottom: 10px solid #f2f1ed;
    }

    .shopping_cart_isnull {
        padding: 160px 25px;
        text-align: center;
        font-size: 14px;
        position: relative;
        .link_btn {
            cursor: pointer;
        }
    }

    .totle_box {
        position: absolute;
        bottom: 40px;
        left: 0;
        right: 0;
        background: #f2f1ed;
        padding: 10px;
        .check_num {
            padding-top: 6px;
            span {
                color: #006ab9;
            }
        }
        .check_price {
            span {
                color: #ff3022;
                font-size: 20px;
                font-weight: 500;
            }
            em {
                font-style: normal;
                font-size: 12px;
            }
        }
    }

    .bottom_btn {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        color: #282b2c;
        background: #fbc500;
        text-align: center;
        cursor: pointer;
        font-weight: 500;
    }
    
}
</style>